// extracted by mini-css-extract-plugin
export default {"header":"NotEnoughBuyingPower_header__5u-Lw","text":"NotEnoughBuyingPower_text__Y8q-e","btnCancel":"NotEnoughBuyingPower_btnCancel__Y0Ry8"};